import React, { FC } from 'react';
import { iconSize } from '../../../../../../../../constants/icon.constants';
import Icon from '../../../../../../../@shared/icon';
import { TGDPRPopupRadioSection } from '../../../../../../types/gdprConsentField.types';

const RadioButtonIcons = ({ checked }): JSX.Element => {
  return (
    <Icon
      iconName={checked ? 'action-radio-checked' : 'action-radio-default'}
      size={iconSize['mbl']}
      extraClassName="gdpr-consent__radio-section-left__radio-icon"
    />
  );
};

const RadioSection: FC<TGDPRPopupRadioSection> = ({ policy, updateData, accepted }) => {
  return (
    <div className="gdpr-consent__radio-section">
      <div className="gdpr-consent__radio-section-title">{policy.title}</div>
      <div className="gdpr-consent__radio-section-options">
        <label>
          <input
            type="radio"
            name={policy.name}
            value={'true'}
            required={policy.required}
            checked={accepted || false}
            onChange={(e) => updateData(policy.id, e.target.value === 'true')}
          />
          <RadioButtonIcons checked={accepted} />
          <p>{policy.acceptLabel}</p>
        </label>
        <label>
          <input
            type="radio"
            name={policy.name}
            value={'false'}
            required={policy.required}
            checked={accepted === false}
            onChange={(e) => updateData(policy.id, e.target.value === 'true')}
          />
          <RadioButtonIcons checked={accepted === false} />
          <p>{policy.denyLabel}</p>
        </label>
      </div>
      <div className="gdpr-consent__radio-section-desc">{policy.description}</div>
    </div>
  );
};

export default RadioSection;
